<template>
  <div class="animated fadeIn">

  </div>
</template>

<script>
import AddVehicleOwnerInfoModal from '@/view/components/add-vehicle-owner-info-modal'
import VehicleOwnerInfoDetailModal from '@/view/components/vehicle-owner-info-detail-modal'

import Vue from 'vue'
import store from '@/store'
import { mapActions } from 'vuex'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
import { numberFormat } from '@/libs/numberutil'

export default {
  name: 'vehiclebrands',
  components: {
  },
  data () {
    return {

    }// return
  }, // data
  methods: {
    ...mapActions([
      'VehicleBrandServ_GetAll'
    ]),
    onSuccess () {
      this.setPage(1)
    },
    onFilterClick () {
      this.setPage(1)
    },
    sortChange ({ column, key, order }) {
      this.sort = {
        name: key,
        asc: order === 'asc'
      }
      this.refreshPage()
    },
    setPage (page) {
      store.dispatch('VehicleBrandServ_GetAll', {
        params: null,
        urlparams: null
      }).then(() => {

      }).catch(err => {
        this.$Message.error(err)
      })
    },
    // 刷新当前页
    refreshPage () {
      this.setPage(this.pageIndex)
    }
  },
  computed: {
    totalElements () {
      if (store.getters.get_VehicleBrand_GetAllResult) {
        return store.getters.get_VehicleBrand_GetAllResult.totalElements
      } else {
        return 0
      }
    },
    content () {
      if (store.getters.get_VehicleBrand_GetAllResult) {
        return store.getters.get_VehicleBrand_GetAllResult.content
      } else {
        return []
      }
    },
    pageSize () {
      if (store.getters.get_VehicleBrand_GetAllResult) {
        return store.getters.get_VehicleBrand_GetAllResult.size
      } else {
        return 0
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.setPage(1)
    })
  }
}
</script>

<style scoped>
</style>
